import type { ReactNode } from 'react';
import { Button } from 'components/Button';
import type IButton from 'components/Button/shared/types/button';
import useSignUpNudgeQuickView from 'components/clubMatas/SignUpNudgeQuickView/shared/hooks/useSignUpNudgeQuickView';

export default function CMSSignupButton({ children, ...restProps }: { children: ReactNode } & IButton) {
    const [, toggle] = useSignUpNudgeQuickView();

    return (
        <Button onClick={() => toggle({ isOpen: true })} {...restProps}>
            {children}
        </Button>
    );
}
